/**
 * Integration API endpoint constants.
 */
export const INTEGRATION_ENDPOINTS = {
    GET_PLANS: '/integrated/plans',
    GET_PLAN_BY_TYPE: '/integrated/plans/', // Base path, will be appended with planType in client
    UPGRADE_SUBSCRIPTION: '/integrated/subscription/upgrade',
    ACTIVATE_COUPON: '/integrated/coupon-activation/activate',
    INITIALIZE_USER: '/integrated/user-initialization/initialize',
    RENEW_SUBSCRIPTION: '/integrated/subscription/renewal',
    RESET_SUBSCRIPTION_TO_FREE: '/integrated/subscription/reset-to-free',
};
//# sourceMappingURL=endpoints.js.map